import { bool, exact, number, string } from "prop-types";
import { baseDatabaseModelType } from "./baseDatabaseModel";

/** @deprecated use TypeScript interface or type instead */
export const userRoleDocumentType = exact({
  ...baseDatabaseModelType,
  id: string.isRequired,
  name: string.isRequired,
  companyCode: string.isRequired,
  isProjectRole: bool.isRequired,
  memberInfo: number.isRequired,
});
